import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Netflix-style horizontal scrollable row with snap + arrow controls.
export const CreatorRow = ({ title, icon: Icon, accent = "blue", testid, children, count }) => {
  const trackRef = useRef(null);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.min(el.clientWidth * 0.85, 900), behavior: "smooth" });
  };

  const accentText = accent === "amber" ? "text-amber-300" : "text-blue-300";

  return (
    <section className="relative py-5" data-testid={testid}>
      <div className="mb-4 flex items-end justify-between pr-6 lg:pr-10">
        <div className="flex items-center gap-3">
          {Icon && (
            <span className={`flex h-8 w-8 items-center justify-center rounded-lg border border-blue-500/20 bg-blue-500/10 ${accentText}`}>
              <Icon size={15} />
            </span>
          )}
          <h2 className="font-display text-xl font-800 tracking-tighter text-white sm:text-2xl">{title}</h2>
          {typeof count === "number" && (
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8AA0C0]">· {count}</span>
          )}
        </div>
        <div className="hidden items-center gap-2 sm:flex">
          <button data-testid={`${testid}-prev`} onClick={() => scrollBy(-1)} aria-label="Précédent"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-blue-500/20 bg-[#0B1220]/70 text-blue-200 transition-colors duration-300 hover:border-blue-400/50 hover:text-white">
            <ChevronLeft size={17} />
          </button>
          <button data-testid={`${testid}-next`} onClick={() => scrollBy(1)} aria-label="Suivant"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-blue-500/20 bg-[#0B1220]/70 text-blue-200 transition-colors duration-300 hover:border-blue-400/50 hover:text-white">
            <ChevronRight size={17} />
          </button>
        </div>
      </div>
      <div
        ref={trackRef}
        className="scrollbar-hide flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 pr-6 lg:pr-10"
      >
        {children}
      </div>
    </section>
  );
};
